import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';

@Component({
  selector: 'page-error',
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.scss']
})
export class PageErrorComponent implements OnInit {

  constructor(public menu: MenuServiceInt, private app: AppComponent, private router: Router) {
    this.menu.display = false;
    this.app.languageIsLoaded = false;
  }

  ngOnInit() { }

  onSubmit() {
    this.router.navigate(['/']);
  }
}
